<template>
  <div class="create-box">
    <Modal v-model="show" title="激活码生成" :width="700" @on-cancel="close(false, '')">
      <Form ref="form" :model="formData" :rules="rule" :label-width="170">
        <FormItem prop="active_type" label="激活码类型:"
          v-if="formData.type === 0 || (formData.type === 1 && formData.safety_code)">
          <Select v-model="formData.active_type" style="width:380px" :disabled="formData.type === 1">
            <Option v-for="item in activeTypes" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="safety_code" label="安全码:" v-if="formData.type === 0">
          <Input v-model="formData.safety_code" placeholder="请输入对应类型的产品安全码，区分大小写" style="width:380px" />
        </FormItem>
        <FormItem label="上传原设备核验文件:" v-if="formData.type === 1">
          <div class="upload" v-if="!formData.safety_code">
            <span class="iconfont">&#xf5a2;</span>
            <input type="file" @change="uploadFile" placeholder="请填写新设备机器码" style="width:380px" class="upload-input" />
          </div>
          <p v-else>已成功上传核验文件</p>
        </FormItem>
        <FormItem prop="mark" :label="`${typesInfo[formData.active_type].label}:`" v-if="formData.active_type >= 0">
          <Input v-model="formData.mark" :placeholder="typesInfo[formData.active_type].tips" style="width:380px" />
        </FormItem>
      </Form>
      <div slot="footer" class="modal-footer">
        <p class="txt"><span class="btn" @click="handleTypeChange">{{formData.type === 1 ? '《通过安全码生成激活码》' : '《通过核验文件生成激活码》'}}</span></p>
        <Button @click="close(false, '')">取消</Button>
        <Button type="primary" @click="activate" :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false,
      loading: false,
      rule: {

      },
      formData: {
        active_type: -1,
        safety_code: '',
        mark: '',
        type: 0
      },
      activeTypes: [
        { value: 0, label: '设备端' },
        { value: 1, label: '文件服务器（负载均衡）' },
        { value: 2, label: '增值功能' }
      ],
      typesInfo: {
        0: {
          label: '机器序列号',
          tips: '请输入机器序列号，区分大小写'
        },
        1: {
          label: '文件服务器识别号',
          tips: '请输入文件服务器识别号，区分大小写'
        },
        2: {
          label: '增值功能识别号',
          tips: '请输入增值功能识别号，区分大小写'
        }
      }

    }
  },
  mounted () {

  },
  methods: {
    ...mapActions(['CreateActivationCode', 'GetCheckFileData']),
    close (status = false, data = '') {
      this.$emit('onClose', { status, data })
    },
    activate () {
      const data = { ...this.formData }
      if (!data.safety_code) {
        this.$Message.error(data.type === 0 ? '请填写安全码' : '请上传核验文件')
        return false
      }
      if (!data.mark) {
        this.$Message.error('请填写识别号')
        return false
      }
      this.$Modal.warning({
        title: '重要提醒',
        content: '请确保输入的“识别号”准确无误，错误的误别号将无法完成对产品的激活，并且确定后不可逆转！',
        onOk: () => {
          this.loading = true
          this.CreateActivationCode(data).then(res => {
            this.loading = false
            if (res.status) {
              this.$Message.success(res.msg)
              this.close(true, res.data)
            } else {
              if (res.code) this.formData.safety_code = ''
              this.$Message.error(res.msg)
            }
          })
        }
      })
    },
    handleTypeChange () {
      this.formData.safety_code = ''
      this.formData.type = this.formData.type === 0 ? 1 : 0
      this.formData.active_type = -1
    },
    uploadFile (e) {
      const file = e.target.files[0]
      this.read(file)
    },
    read (f) {
      let rd = new FileReader()
      rd.onload = e => {
        let cont = rd.reading({ encode: 'UTF-8' })
        if (!cont) {
          this.$Message.error('读取文件失败')
          return false
        }
        this.GetCheckFileData({ safety_code: cont }).then(res => {
          if (res.status) {
            this.formData.active_type = res.data.type
            this.formData.safety_code = cont
            this.$Message.success('已成功上传核验文件')
          } else {
            this.$Message.error(res.msg)
          }
        })
      }
      rd.readAsBinaryString(f)
    }

  },
  computed: mapGetters({

  }),
  watch: {
    visible: function () {
      this.show = this.visible
      this.formData = {
        active_type: -1,
        safety_code: '',
        mark: '',
        type: 0
      }
    }
  },
  beforeCreate () {
    // 读取文件
    FileReader.prototype.reading = function ({ encode } = pms) {
      let bytes = new Uint8Array(this.result) // 无符号整型数组
      let text = new TextDecoder(encode || 'UTF-8').decode(bytes)
      return text
    }
    /* 重写readAsBinaryString函数 */
    FileReader.prototype.readAsBinaryString = function (f) {
      if (!this.onload) // 如果this未重写onload函数，则创建一个公共处理方式
      {
        this.onload = e => { // 在this.onload函数中，完成公共处理
          let rs = this.reading()
          console.log(rs)
        }
      }
      this.readAsArrayBuffer(f) // 内部会回调this.onload方法
    }
  }
}
</script>
<style lang='less'>
@import "./index.less";
</style>
